import _get from 'lodash/get'

export default {
  state: {
    keys: _get(window, 'appInitialData.stores.Settings', [])
  },
  getters: {
    Settings: state => {
      return state.keys
    }
  },
  mutations: {},
  actions: {}
}
